import toastr from 'react-hot-toast';
import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import { generateSortQuery, generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { SparkContentCardCategoryResponse } from 'types/Spark/SparkContentCardCategory';

const getSparkContentCardCategories = () => {
  const queryArray = [generateSortQuery('sortOrder', 'Acs')];

  const url = generateURL(
    SPARK_RESOURCE_TYPES.SPARK_CONTENT_CARD_CATEGORIES,
    queryArray
  );

  return fetchWrapper<SparkContentCardCategoryResponse>({
    url: url,
    method: 'GET',
  });
};

export function useSparkContentCardCategories() {
  const response = useQuery(
    ['sparkContentCardCategories'],
    getSparkContentCardCategories,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `Failed to fetch Spark content card categories: ${error.message}`
          );
        }
      },
      ...CACHE_AND_STALE_TIME,
    }
  );
  const { data: sparkContentCardCategories } = response.data || {};

  return {
    sparkContentCardCategories,
    ...response,
  };
}
